import {KPBoardSubCategory} from "./KPBoardSubCategory";
import {KPPost} from "./KPPost";

export interface KPBoard {
  // DB Fields
  uid: number;
  companyUID: number; // NOT USED
  name: string; // 게시판 이름
  displayOrder: number; // 표시순서
  isDeleted: boolean; // 삭제여부
  entryDate: Date | string;
  modifyDate: Date | string;

  // NOT DB
  subCategories: KPBoardSubCategory[];
  posts: KPPost[]; // 게시글 목록
  postCount: number; // 게시글 개수
}

export const initializeBoard = (companyUID = 0): KPBoard => {
  return {
    uid: 0,
    companyUID: companyUID,
    name: "",
    displayOrder: 0,
    isDeleted: false,
    entryDate: new Date(),
    modifyDate: new Date(),

    // NOT DB
    subCategories: [] as KPBoardSubCategory[],
    posts: [] as KPPost[],
    postCount: 0,
  };
};

export interface BoardPostListParams {
  token: string;
  page?: number;
  rows?: number;
  boardUID: number; // 게시판 UID
  subCategoryUID: number; // 분류 UID - 0 이면 전체
  searchWord: string; // 검색어
}

export const initializeBoardListParams = (boardUID = 0, subCategoryUID = -1) => {
  return {
    token: "",
    page: 1,
    rows: 30,
    boardUID: boardUID, // 게시판 UID
    subCategoryUID: subCategoryUID, // 분류 UID - 0 이면 전체
    searchWord: "", // 검색어
  };
};
